var map = {
	"./bl.png": "JyUo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DJGS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/enterImg ^\.\/bl.*\.png$
// module id = DJGS
// module chunks = 1